import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="August 17, 2026" testid="privacy-page">
      <p className="text-white/70">
        Mobyle (&quot;Mobyle&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) builds custom websites, apps and
        AI automations. This Privacy Policy explains what information we collect
        when you visit our website or contact us, how we use it, and the choices
        you have. By using our site you agree to this policy.
      </p>

      <LegalSection heading="1. Information we collect">
        <p>
          <span className="text-white/85 font-medium">Information you give us.</span>{" "}
          When you submit our contact form, request a build consult, chat with us,
          or book a call, we collect details such as your name, email address,
          phone number, company, budget range and the project information you
          share.
        </p>
        <p>
          <span className="text-white/85 font-medium">Information collected automatically.</span>{" "}
          Like most websites, we may collect standard technical data such as your
          IP address, browser type, device information, referring pages and
          interaction data through cookies and similar technologies.
        </p>
      </LegalSection>

      <LegalSection heading="2. How we use your information">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>To respond to your enquiries and provide the consult or services you request.</li>
          <li>To prepare proposals, blueprints, timelines and pricing.</li>
          <li>To operate, maintain and improve our website and services.</li>
          <li>To send you relevant updates about your project or our services (you can opt out at any time).</li>
          <li>To comply with legal obligations and protect our rights.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. How we share information">
        <p>
          We do not sell your personal information. We may share it with trusted
          third-party providers who help us operate our business — for example
          form and CRM providers, scheduling tools, email delivery, analytics and
          hosting. These providers are only permitted to use your information to
          perform services for us. We may also disclose information where required
          by law.
        </p>
      </LegalSection>

      <LegalSection heading="4. Cookies">
        <p>
          We use cookies and similar technologies to keep the site functioning,
          remember preferences and understand how the site is used. You can control
          cookies through your browser settings; disabling them may affect some
          features.
        </p>
      </LegalSection>

      <LegalSection heading="5. Data retention & security">
        <p>
          We keep personal information only for as long as needed for the purposes
          described here or as required by law. We use reasonable technical and
          organisational measures to protect your information, though no method of
          transmission or storage is completely secure.
        </p>
      </LegalSection>

      <LegalSection heading="6. Your rights">
        <p>
          Depending on where you live, you may have the right to access, correct,
          delete or restrict the use of your personal information, or to object to
          certain processing. To exercise these rights, contact us using the
          details below.
        </p>
      </LegalSection>

      <LegalSection heading="7. Third-party links">
        <p>
          Our site may link to third-party websites and services (such as scheduling
          or form tools). We are not responsible for the privacy practices of those
          third parties and encourage you to review their policies.
        </p>
      </LegalSection>

      <LegalSection heading="8. Changes to this policy">
        <p>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page with an updated &quot;Last updated&quot; date.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contact us">
        <p>
          If you have any questions about this Privacy Policy or your information,
          contact us at{" "}
          <a href="mailto:hello@gomobyle.com" className="text-teal hover:underline">
            hello@gomobyle.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
